/* Geolocation - Cross-store redirect for aemery.com (Global) and us.aemery.com (US) */

const GLOBAL_DOMAIN = 'aemery.com';
const US_DOMAIN = 'us.aemery.com';
const COOKIE_NAME = 'store_choice';
const COOKIE_DAYS = 7;
const LOG_PREFIX = '[Geo]';
const LOOP_STORAGE_KEY = 'loop-onstore-data';

const EUROPE_CODES = [
  'AL', 'AD', 'AM', 'AT', 'AZ', 'BY', 'BE', 'BA', 'BG', 'HR', 'CY', 'CZ', 'DK',
  'EE', 'FI', 'FR', 'GE', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'KZ', 'XK', 'LV',
  'LI', 'LT', 'LU', 'MT', 'MD', 'MC', 'ME', 'NL', 'MK', 'NO', 'PL', 'PT', 'RO',
  'RU', 'SM', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'TR', 'UA', 'VA'
];

function isBot() {
  return /bot|crawl|spider|slurp|googlebot|google-inspectiontool|googleother|lighthouse|bingbot|yandex|baidu|duckduckbot|facebookexternalhit|twitterbot|linkedinbot|semrush|ahref|mj12bot|dotbot|petalbot|bytespider/i.test(navigator.userAgent);
}

function log() {
  console.log.apply(console, [LOG_PREFIX].concat(Array.prototype.slice.call(arguments)));
}

function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(";").shift().trim());
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/';
}

/*
 * Loop Returns "Shop Now on store" hands the shopper over to the storefront with
 * loop_* query params, which the Loop app embed reads once and then persists to
 * localStorage (per origin) before stripping them from the URL.
 *
 * Anything we do here that crosses origins or drops the query string destroys
 * that handover: a cross-store redirect strands the return on the wrong Loop
 * instance, and the localization form POST loses the params entirely. Either way
 * the shopper ends up at a normal Shopify checkout with no return credit.
 *
 * So while a Loop session is in play, geolocation stays out of the way.
 */
function hasLoopSession() {
  if (/[?&]loop_[a-z_]+=/i.test(window.location.search)) return true;

  try {
    const raw = localStorage.getItem(LOOP_STORAGE_KEY);
    if (raw) {
      const data = JSON.parse(raw);
      // Loop nulls `params` when the shopper heads back to Loop, so a stored
      // blob on its own doesn't mean the session is still live.
      if (data && data.params) return true;
    }
  } catch (e) {
    // localStorage unavailable or malformed entry - fall through
  }

  return !!(document.body && document.body.classList.contains('loop-returns-activated'));
}

function isOnUSSite() {
  const h = window.location.hostname;
  return h === US_DOMAIN || h === 'www.' + US_DOMAIN;
}

function isOnGlobalSite() {
  return !isOnUSSite();
}

function isProductionDomain() {
  return window.location.hostname.endsWith('aemery.com');
}

function getStoreType() {
  if (isProductionDomain()) {
    return isOnUSSite() ? 'us' : 'global';
  }
  return (typeof window.AEMERY_STORE_TYPE === 'string') ? window.AEMERY_STORE_TYPE : 'global';
}

function redirectToStore(domain, choice) {
  if (hasLoopSession()) {
    log('Loop On-Store session active, refusing cross-store redirect');
    return;
  }
  const path = window.location.pathname + window.location.search;
  const sep = path.indexOf('?') >= 0 ? '&' : '?';
  const url = 'https://' + domain + path + sep + 'store_choice=' + encodeURIComponent(choice);
  log('REDIRECTING to', url);
  setCookie(COOKIE_NAME, choice, COOKIE_DAYS);
  sessionStorage.geoDetectionDone = '1';
  sessionStorage.geoRedirectCount = (parseInt(sessionStorage.geoRedirectCount || '0', 10) + 1).toString();
  window.location.href = url;
}

function setLocalization(countryCode) {
  if (hasLoopSession()) {
    log('Loop On-Store session active, refusing localization form submit');
    return;
  }
  const form = document.querySelector('#localization_form') || document.querySelector('.store-selector__hidden-form');
  const input = form ? form.querySelector('input[name="country_code"]') : null;
  if (form && input) {
    log('Submitting localization form for', countryCode);
    input.value = countryCode;
    // Shopify renders return_to from the request that generated the HTML, so on a
    // full-page-cached response it can point at somebody else's URL and silently
    // drop the current query string. Always post back to where we actually are.
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo) {
      returnTo.value = window.location.pathname + window.location.search;
    }
    sessionStorage.geoDetectionDone = '1';
    form.submit();
  } else {
    log('No form found, setting localization cookie and reloading');
    document.cookie = 'localization=' + countryCode + '; expires=' + new Date(new Date().getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000).toUTCString() + '; path=/';
    sessionStorage.geoDetectionDone = '1';
    location.reload();
  }
}

function mapCountryToChoice(countryCode) {
  if (countryCode === 'US') return { store: 'us', localization: 'US' };
  if (countryCode === 'AU' || countryCode === 'NZ') return { store: 'global', localization: 'AU' };
  if (EUROPE_CODES.includes(countryCode)) return { store: 'global', localization: 'FR' };
  if (countryCode === 'GB') return { store: 'global', localization: 'GB' };
  return { store: 'global', localization: 'CA' };
}

function run() {
  if (isBot()) {
    log('Bot detected, skipping geo-redirect');
    return;
  }

  if (hasLoopSession()) {
    log('Loop On-Store session detected, skipping geo-redirect entirely');
    return;
  }

  log('--- RUN START ---');
  log('hostname:', window.location.hostname, '| path:', window.location.pathname, '| search:', window.location.search);
  log('isOnUSSite:', isOnUSSite(), '| isOnGlobalSite:', isOnGlobalSite(), '| isProductionDomain:', isProductionDomain());
  log('AEMERY_STORE_TYPE:', typeof window.AEMERY_STORE_TYPE !== 'undefined' ? window.AEMERY_STORE_TYPE : 'undefined', '| getStoreType():', getStoreType());
  log('sessionStorage.geoDetectionDone:', sessionStorage.geoDetectionDone, '| geoRedirectCount:', sessionStorage.geoRedirectCount);

  const urlParams = new URLSearchParams(window.location.search);
  const countryOverride = urlParams.get('country');
  const storeChoiceParam = urlParams.get('store_choice');

  log('URL params: country=', countryOverride, '| store_choice=', storeChoiceParam);
  log('Cookie store_choice:', getCookie(COOKIE_NAME));

  var redirectCount = parseInt(sessionStorage.geoRedirectCount || '0', 10);
  if (redirectCount >= 3) {
    log('LOOP GUARD: redirect count >= 3, aborting');
    sessionStorage.geoRedirectCount = '0';
    return;
  }

  if (storeChoiceParam) {
    const choice = storeChoiceParam.toUpperCase();
    log('Step 1: Found store_choice in URL:', choice);
    if (['US', 'AU', 'FR', 'GB', 'CA'].includes(choice)) {
      setCookie(COOKIE_NAME, choice, COOKIE_DAYS);
      log('Set cookie to', choice, 'and stripping param from URL');
      urlParams.delete('store_choice');
      const newSearch = urlParams.toString();
      history.replaceState({}, document.title, window.location.pathname + (newSearch ? '?' + newSearch : ''));
    }
  }

  let resolvedChoice = null;
  if (countryOverride) {
    log('Step 2: Found country override in URL:', countryOverride);
    history.replaceState({}, document.title, window.location.pathname);
    const mapped = mapCountryToChoice(countryOverride.toUpperCase());
    resolvedChoice = mapped.localization;
    setCookie(COOKIE_NAME, resolvedChoice, COOKIE_DAYS);
    log('Mapped to', mapped, '| resolvedChoice:', resolvedChoice);
  }

  if (!resolvedChoice) {
    const cookieChoice = getCookie(COOKIE_NAME);
    if (cookieChoice) {
      resolvedChoice = cookieChoice.toUpperCase().replace(/^["']|["']$/g, '');
      log('Step 3: Read resolvedChoice from cookie:', resolvedChoice);
    }
  }

  if (resolvedChoice) {
    const choice = { store: resolvedChoice === 'US' ? 'us' : 'global', localization: resolvedChoice };
    const storeType = getStoreType();
    log('Step 4: Apply choice. resolvedChoice:', resolvedChoice, '| choice:', JSON.stringify(choice), '| storeType:', storeType);

    if (choice.store === 'us' && storeType === 'global') {
      log('Action: Need US store, currently on Global -> redirect to US');
      if (isProductionDomain()) {
        redirectToStore(US_DOMAIN, 'US');
      } else {
        log('Skipping redirect: not production domain');
      }
      return;
    }

    if (choice.store === 'global' && storeType === 'us') {
      log('Action: Need Global store (AU/FR/GB), currently on US store -> redirect to Global');
      if (isProductionDomain()) {
        redirectToStore(GLOBAL_DOMAIN, choice.localization);
      } else {
        log('Skipping redirect: not production domain');
      }
      return;
    }

    if (choice.store === 'global' && storeType === 'global') {
      const input = document.querySelector('#localization_form input[name="country_code"]') || document.querySelector('.store-selector__hidden-form input[name="country_code"]');
      const current = input ? input.value : null;
      log('Action: On Global store, check localization. current:', current, '| wanted:', choice.localization);
      if (current !== choice.localization) {
        setLocalization(choice.localization);
      } else {
        log('Already on correct localization');
      }
    } else {
      log('Action: No action needed (already on correct store)');
    }
    log('--- RUN END (resolved) ---');
    return;
  }

  if (sessionStorage.geoDetectionDone) {
    log('Step 5: Skipping auto-detect - geoDetectionDone already set');
    log('--- RUN END (skip detect) ---');
    return;
  }

  log('Step 5: No cookie/override - fetching geolocation');
  const url = window.location.protocol + '//' + window.location.hostname + '/browsing_context_suggestions.json';
  fetch(url)
    .then(function(response) { return response.json(); })
    .then(function(data) {
      let country = data.detected_values && data.detected_values.country ? data.detected_values.country.handle : null;
      log('Detected country:', country);
      if (!country) {
        log('No country detected, exiting');
        sessionStorage.geoDetectionDone = '1';
        return;
      }

      const choice = mapCountryToChoice(country);
      const storeType = getStoreType();
      log('Mapped to:', JSON.stringify(choice), '| storeType:', storeType);
      sessionStorage.geoDetectionDone = '1';

      if (choice.store === 'us' && storeType === 'global') {
        log('Auto-detect: US detected on Global store -> redirect');
        if (isProductionDomain()) {
          setCookie(COOKIE_NAME, 'US', COOKIE_DAYS);
          redirectToStore(US_DOMAIN, 'US');
        } else {
          log('Skipping redirect: not production domain');
        }
        return;
      }
      if (choice.store === 'global' && storeType === 'us') {
        log('Auto-detect: AU/FR/GB detected on US store -> redirect to Global');
        if (isProductionDomain()) {
          setCookie(COOKIE_NAME, choice.localization, COOKIE_DAYS);
          redirectToStore(GLOBAL_DOMAIN, choice.localization);
        } else {
          log('Skipping redirect: not production domain');
        }
        return;
      }
      if (choice.store === 'global' && storeType === 'global') {
        const input = document.querySelector('#localization_form input[name="country_code"]') || document.querySelector('.store-selector__hidden-form input[name="country_code"]');
        const current = input ? input.value : null;
        log('Auto-detect: On Global store, set localization. current:', current, '| wanted:', choice.localization);
        if (current !== choice.localization) {
          setCookie(COOKIE_NAME, choice.localization, COOKIE_DAYS);
          setLocalization(choice.localization);
        }
      } else {
        log('Auto-detect: No action needed');
      }
      log('--- RUN END (fetch done) ---');
    })
    .catch(function(err) {
      console.error(LOG_PREFIX, 'Error fetching country data:', err);
      log('--- RUN END (error) ---');
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', run);
} else {
  run();
}
